(() => {
  const article = document.querySelector('[data-twt-article]');
  if (!article) return;

  const content = article.querySelector('[data-twt-article-content]');
  const toc = article.querySelector('[data-twt-article-toc]');
  const list = article.querySelector('[data-twt-article-toc-list]');
  if (!content || !toc || !list) return;

  const headings = [...content.querySelectorAll('h2')];
  if (headings.length < 2) return;

  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `article-section-${index + 1}`;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent;
    list.append(link);
  });
  toc.hidden = false;

  if (!('IntersectionObserver' in window)) return;
  const links = [...list.querySelectorAll('a')];
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${entry.target.id}`));
    });
  }, { rootMargin: '-20% 0px -70%' });
  headings.forEach((heading) => observer.observe(heading));
})();
